export default __webpack_public_path__ + "static/media/img-0268-saudi-arabia-half-face.574b9715.png";